import styled from "styled-components";
import {ButtonHTMLAttributes} from "react";

export enum ButtonVariant {
    TEXT = "text",
    OUTLINED = "outlined",
    CONTAINED = "contained"
}

export enum ButtonColor {
    PRIMARY = "var(--button-primary-color)",
    SECONDARY = "var(--button-secondary-color)",
    DEFAULT = "var(--text-color-main)"
}

export interface ButtonProps {
    isActive?: boolean,
    variant?: ButtonVariant,
    color?: ButtonColor
}

const colorByEnum = (colorEnumItem: ButtonColor) => {
    switch (colorEnumItem) {
        case ButtonColor.PRIMARY:
            return "#000"
        case ButtonColor.SECONDARY:
            return "#000"
        case ButtonColor.DEFAULT:
            return "var(--background-dark-200)"
    }
}

const getHoverColor = (variant: ButtonVariant, color: ButtonColor, isLight: boolean) => {
    if (!isLight) {
        return color
    }

    switch (color) {
        case ButtonColor.DEFAULT:
            return "var(--background-hover)"
        case ButtonColor.PRIMARY:
            if (variant === ButtonVariant.CONTAINED) {
                return "var(--button-primary-color-hover)"
            }
            return "rgb(171, 201, 251, 0.1)"
        case ButtonColor.SECONDARY:
            return "#adadad"
    }
}

const getStylesByColorAndVariant = (variant: ButtonVariant, color: ButtonColor, isLight: boolean) => {
    if (variant === ButtonVariant.CONTAINED) {
        return {
            background: getHoverColor(variant, color, isLight),
            color: colorByEnum(color),
        }
    } else if (variant === ButtonVariant.OUTLINED) {
        return {
            color: getHoverColor(variant, color, isLight),
            border: "1px solid " + getHoverColor(variant, color, isLight)
        }
    }
    if (isLight) {
        return {
            color: color,
            background: getHoverColor(variant, color, isLight),
        }
    }

    return {
        color: getHoverColor(variant, color, isLight),
    }
}

    const Button = styled.button.attrs<ButtonHTMLAttributes<HTMLButtonElement>>(props => {
        return {
            className: `button` + (props.className ? " " + props.className : ""),
        }
    })<ButtonProps>`
  position: relative;
  display: inline-flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  border: none;
  color: inherit;
  min-height: 48px;
  padding: 0 16px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 8px;
  transition: all 0.1s ease;
  font-family: var(--font-family);
  text-decoration: none;
  font-size: 16px;
  background: transparent;
  letter-spacing: 0;
  user-select: none;
  white-space: nowrap;
      ${props => {
        return props.disabled ? {
            pointerEvents: "none",
            opacity: 0.7
        } : {}
      }}
      
    ${props => {
        return getStylesByColorAndVariant(props.variant ?? ButtonVariant.TEXT, props.color ?? ButtonColor.DEFAULT, !!props.isActive)
    }}
  
    &:hover {
        ${props => {
            return getStylesByColorAndVariant(props.variant ?? ButtonVariant.TEXT, props.color ?? ButtonColor.DEFAULT, true)
        }}
    }
    &:active {
      transform: translateY(1px);
    }
`



export default Button